export default __webpack_public_path__ + "static/media/plants.86fe2a33.png";